import angular from 'angular';

function odAnchorScrollOffsetFromAncestors($document) {
  var el = $document[0].querySelector('*[od-anchor-scroll-offset]');
  return angular.element(el).controller('odAnchorScrollOffset') ||
         { getOffset: function() { return 0; } };
}

// Define the offset for scrolling based on an element's position (such as a
// position: fixed nav or subnav).
module.exports = angular.module('market.directives.od-anchor-scroll', [])
.directive('odAnchorScrollOffset', function() {
  return {
    restrict: 'A',
    scope: {},
    controller: function($scope) {
      this.getOffset = function() { return $scope.offset; };
    },
    link: function(scope, element, attrs) {
      var side = attrs.odAnchorScrollOffset || 'bottom';
      scope.offset = element[0].getBoundingClientRect()[side];
    }
  };
})

// from duScroll.smoothScroll
.directive('odAnchorScroll', function($document) {
  return {
    restrict: 'A',
    require: '?^odAnchorScrollOffset',
    link: function(scope, element, attrs, odAnchorScrollOffset) {
      if (!attrs.href || attrs.href.indexOf('#') === -1) return;

      if (!odAnchorScrollOffset)
        odAnchorScrollOffset = odAnchorScrollOffsetFromAncestors($document);
      var offset = odAnchorScrollOffset.getOffset();

      var id = attrs.href.replace(/.*(?=#[^\s]+$)/, '').substring(1)
        , target = $document[0].getElementById(id);

      element.on('click', function(e) {
        target = target || $document[0].getElementById(id);
        if (!target || !target.getBoundingClientRect) return;

        offset = offset || odAnchorScrollOffset.getOffset();

        if (e.stopPropagation) e.stopPropagation();
        if (e.preventDefault) e.preventDefault();

        $document.scrollTo(angular.element(target), offset, 300);
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/directives/od-anchor-scroll.js
 **/